import { Integration } from "../../../../../types"
import { useIntegrationSettingsForm } from "../../../../hooks"
import If from "../../../if"
import RateCardsSelector from "../rate-cards-selector"

interface Props {
  integration?: Integration
}

const RateCardsOption = ({ integration }: Props) => {
  const { app_settings, saveSetting } = useIntegrationSettingsForm(integration)

  const { settings } = app_settings ?? {}

  // Check if there's a rateCardsConfigId set in settings
  const hasRateCardsConfig = !!(settings as Record<string, unknown>)
    ?.rateCardsConfigId

  const isChecked = settings?.rateCards ?? hasRateCardsConfig

  const onChangeRateCards = () => {
    saveSetting({
      rateCards: !isChecked,
      ...(isChecked && { rateCardsConfigId: null })
    })
  }

  return (
    <div className="py-2">
      <input
        onChange={onChangeRateCards}
        checked={isChecked}
        id="rateCards"
        name="rateCards"
        type="checkbox"
        className="h-6 w-6 rounded border-neural-400 text-primary-500 focus:ring-primary-300 cursor-pointer"
      />
      <label htmlFor="rateCards" className="select-none ml-3 cursor-pointer">
        Rate Cards
      </label>
      <If
        condition={!!integration && isChecked}
        then={<RateCardsSelector integration={integration!} />}
      />
    </div>
  )
}

export default RateCardsOption
